
import { defineComponent } from 'vue';
import { i18n } from '@tencent/vb-web-base';
import { baseMixins } from '@common/mixins/baseMixins';
export default defineComponent({
  name: 'RightMerchant',
  setup() {
    const { getT } = i18n;
    const $t = getT();
    const { setTitle } = baseMixins();
    setTitle($t('礼遇合作商户信息'));
    return {};
  },
});
